import { KENTICO_TYPES } from 'common/consts/kentico';
import Client from './kenticoClient';

class GlobalMetaTagsService {
  async fetchMetaTagsData() {
    const items = await Client.items()
      .type(KENTICO_TYPES.GLOBAL_META_TAGS)
      .toPromise();

    if (items.isEmpty) {
      return null;
    }

    return items.lastItem;
  }
}

export default new GlobalMetaTagsService();



// WEBPACK FOOTER //
// ./src/services/GlobalMetaTags.service.js